import React, {useEffect} from 'react'
import { observer } from "mobx-react-lite"
import Header from '../header/Header'
import useTitle from '../../hooks/title'
import classes from './Reviews.module.scss'
import useWindowSize from '../../hooks/window-size';
import { useLocation } from "@reach/router"

const links = ["cw-ux40-U2M",
              "IZH99K7LSWo", 
              "YkWw3nIWKZw",
              "2UHWDb5JV68",
              "OjQ-JjDq-kU",
              "Ik7F6pXpwVs",
              "V-kJtA1_xUc",
              "MIZxBQcT-88",
              "512gHJJO1qI",
              "bNUACE5kqj8",
              "5_NyfvzgOMc",
              "jlTP7a0k4NI",
              "0OLrvsaIyys",
              "YPHyZeIKPBI",
              "ZHtA93r66Xc",
              "2i_KNQvU3-U",
              "WUIuBcy0xPs",
              "UtYNHHNulSE",
              ]

const Reviews = observer(() => {
    useTitle('Customer Reviews', 'See what musicians and producers say about Session Loops, VocalNet, and DrumNet. Real reviews from real music creators.', '/reviews');
    const windowSize = useWindowSize();
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [location.pathname])

    function Video(src, index)
    {
      return <div className={classes['video']} key={index}>
        <div className={classes['auto-resizable']}>
          <div className={classes['auto-resizable-div']}>
            <iframe className={classes['auto-resizable-iframe']} src={'https://www.youtube.com/embed/' + src} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
    </div>
    }
    return <div className={classes.root}>
      {windowSize.width < 500 ? <Header /> : <Header normal/>}
      <div className={classes['background']}>
        <div className={classes['container']}>
            <div className={classes['title1']}>Youtube Reviews</div>
            <div className={classes['title2']}>What Pros Are Saying</div>
            <div className={classes['title2']}>About Us</div>
            <div className={classes['container']}>
              <div className={classes['viewer-bg-fc']}></div>
              {links.map((link, index) => Video(link, index))}
            </div>
        </div>
      </div>
    </div>
  })
  
  export default Reviews